import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import classNames from 'classnames';
import SvgDragHandleBars24 from '../../../icons/interface/DragHandleBars24.js';
import { isCursorTop } from '../../../helpers/dragAndDrop.js';
import { useDrop } from '../../../node_modules/react-dnd/dist/hooks/useDrop/useDrop.js';
import { useDrag } from '../../../node_modules/react-dnd/dist/hooks/useDrag/useDrag.js';

var DragDropRow = function (_a) {
    var children = _a.children, disabled = _a.disabled, rowIndex = _a.rowIndex, onRowMoved = _a.onRowMoved, trProps = __rest(_a, ["children", "disabled", "rowIndex", "onRowMoved"]);
    var ref = useRef(null);
    var _b = useDrop({
        accept: 'row',
        drop: function (_a, monitor) {
            var sourceIndex = _a.sourceIndex;
            var above = isCursorTop(monitor, ref.current.getBoundingClientRect());
            var newRawIndex = above ? rowIndex : rowIndex + 1;
            var newIndex = newRawIndex > sourceIndex ? newRawIndex - 1 : newRawIndex;
            if (sourceIndex !== newIndex) {
                onRowMoved(sourceIndex, newIndex);
            }
        }
    }, [rowIndex]), dropRef = _b[1];
    var _c = useDrag({
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging()
        }); },
        item: { sourceIndex: rowIndex },
        type: 'row'
    }, [rowIndex]), isDragging = _c[0].isDragging, dragRef = _c[1], previewRef = _c[2];
    previewRef(dropRef(ref));
    return (jsxs("tr", __assign({ ref: ref }, trProps, { className: classNames(isDragging && 'opacity-50', trProps.className) }, { children: [jsx("td", __assign({ className: "position-relative" }, { children: jsx("button", __assign({ ref: dragRef, className: classNames('btn btn-darker-quartenary text-default rounded-0 p-0 absolute-fill', disabled && 'pe-none opacity-20') }, { children: jsx("span", __assign({ "aria-hidden": "true", "data-testid": "drag-handle" }, { children: jsx(SvgDragHandleBars24, { className: "position-absolute start-50 translate-middle-x opacity-100 table-cell-square-icon" }) })) })) })), children] })));
};

export { DragDropRow };
